import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { HTMLAsset } from '@techstyle/react-assets';

import { Component as FplsAsset } from '../FplsAsset';
import { Component as ProductCell } from '../ProductCell';
import TemplateButtons from '../TemplateButtons/TemplateButtons';

const Wrapper = styled.div`
  ${props =>
    props.shouldHidePrice &&
    `
      ${ProductCell.PriceWrapper},
      ${ProductCell.PromoTextWrapper} {
        display: none;
      }
  `}
  ${ProductCell.FlagWrapper} {
    margin-top: ${({ theme }) => theme.spacing.tiny}px !important;
  }
`;

const LastCell = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;

  &[data-span='fullWidth'] {
    padding-bottom: 32px;
  }
`;

const SquareWrapper = styled.div`
  flex: 1 0 auto;
  text-align: center;
`;

export default class TemplateFplsAsset extends React.PureComponent {
  static propTypes = {
    additionalParams: PropTypes.object,
    applyUserSizes: PropTypes.bool,
    asset: PropTypes.object.isRequired,
    assetSlots: PropTypes.object,
    className: PropTypes.string,
    pSource: PropTypes.string,
    shouldHidePrice: PropTypes.bool,
  };

  static defaultProps = {
    applyUserSizes: true,
  };

  renderLastCell(asset) {
    if (!asset.options.htmlText && !asset.options.customVars.ctaText) {
      return null;
    }

    const { slotCount } = asset.options.customVars;

    return (
      <LastCell data-span={slotCount}>
        <SquareWrapper>
          <HTMLAsset asset={asset} />
          <TemplateButtons
            asset={asset}
            largeButton={false}
            fullWidth={false}
          />
        </SquareWrapper>
      </LastCell>
    );
  }

  render() {
    const {
      additionalParams,
      applyUserSizes,
      asset,
      assetSlots,
      breakpoints,
      className,
      pSource,
      shouldHidePrice,
    } = this.props;
    const sizeLimit = asset.options.customVars.fplProductsCount;
    return (
      <Wrapper className={className} shouldHidePrice={shouldHidePrice}>
        <FplsAsset
          asset={asset}
          assetSlots={assetSlots}
          applyUserSizes={applyUserSizes}
          additionalParams={additionalParams}
          breakpoints={breakpoints}
          pSource={pSource}
          sizeLimit={sizeLimit || 100}
        >
          {this.renderLastCell(asset)}
        </FplsAsset>
      </Wrapper>
    );
  }
}
